import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//import { InspeccionService } from 'src/app/services/inspeccion.service';
import { ObservableInspService } from 'src/app/services/observable_insp';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-ingresos-insp',
  templateUrl: './ingresos-insp.component.html',
  styleUrls: ['./ingresos-insp.component.css'],
  providers: [UserService]


})
export class IngresosInspComponent implements OnInit {
  formTipo: FormGroup;
  tipoIngreso;
  formArray: any;
  valTipoIngreso;
  tipoIng;
  respTipoIngreso;
  observacionForm: FormGroup;
  seleccionados;
  idsTiposOcupaciones = [];
  descTipo = [];
  boxSelected = [];
  checkch: any[];

  constructor(private _formBuilder: FormBuilder,
    private _inspeccionService: UserService, private observableService: ObservableInspService, private _changeDetector: ChangeDetectorRef,

  ) {
    //console.log("avu ingresos-inp constructor")
    this.checkch = [];
    this.observacionForm = this._formBuilder.group({
      observacion: ["", [Validators.required]],
    });
    this.formTipo = this._formBuilder.group({
      ArrForms: this._formBuilder.array([], Validators.required),
    });
    //console.log("avu ingresos-inp constructor 2")
    this.getTipoIngreso();

  }

  ngOnInit(): void {
    this.boxSelected = [];
    console.log('ventana step 3');
  }

  getTipoIngreso() {
    //console.log("inicio get ts");
    this._inspeccionService.getTipoIngreso().subscribe(
      (response) => {
        //console.log('getTipoIngreso response ', response);
        this.tipoIng = [];
        //console.log("Tipo de Ocupaciones", response.data);
        this.respTipoIngreso = response.data;
        this.tipoIng = this.respTipoIngreso.map((tipo) => {
          //console.log("val", this.tipoIng, tipo.fieldData);
          return tipo.fieldData;
          //console.log("val", this.tipoIng, tipo.fieldData);
        });

        this.tipoIng = this.tipoIng.filter(data => (data._TRAEXP_Cod === 4));



        //console.log(this.tipoIng, 'tip');

        this.inicializarFormulario();

      },

      (error) => {
        console.log('error', error);
      }
    );
  }





  getFormulario() {
    this.idsTiposOcupaciones = [];
    this.descTipo = [];

    this.observableService.comentario$.emit(this.observacionForm.controls.observacion.value);
    //console.log('DATA CHECK', this.formArray);

    this.seleccionados = <FormArray>this.formTipo.value.ArrForms;

    //console.log('valor formarray', this.seleccionados);
    this.seleccionados.forEach((tipo: any) => {
      // console.log('tipo:: ', tipo);
      if (tipo.tipoOcupacionCheck === true) {
        this.idsTiposOcupaciones.push(tipo.tipoOcupacionId);
        this.descTipo.push(tipo.tipoOcupacionLabel)
      }
      this.observableService.tiposInsp$.emit(this.idsTiposOcupaciones.toString());
      this.observableService.siglasId$.emit(this.descTipo.toString());

      //console.log('aaaa', this.idsTiposOcupaciones.toString());
      //console.log('eee', this.descTipo.toString() );
    });

    this.idsTiposOcupaciones

    // // if (this.thirdFormGroup.controls.coordenada1.status=="VALID",
    // //     this.thirdFormGroup.controls.coordenada2.status=="VALID"

    // // ) {
    // //    this.blockButton  = true ;

    // // }


  }


  checkboxChange(event, check) {
    //console.log('event.checked:: ', check);
    this._changeDetector.detectChanges;
    this.boxSelected = this.formArray.controls
    if (event) {
      const index = this.checkch.findIndex(c => c.tipoOcupacionId.value === check.tipoOcupacionId.value);
      if (index !== -1) {
        this.checkch.splice(index, 1);
      } else {
        this.checkch.push(check);
      }
    } else {
      const index = this.checkch.findIndex(c => c.tipoOcupacionId.value === check.tipoOcupacionId.value);
      if (index !== -1) {
        this.checkch.splice(index, 1);
      }
    }

    this._changeDetector.detectChanges;

    //console.log('box selected', this.checkch);

  }

  inicializarFormulario() {
    this.formTipo = this._formBuilder.group({
      ArrForms: this._formBuilder.array([], Validators.required),
    });
    this.formArray = <FormArray>this.formTipo.controls.ArrForms;
    for (let i = 0; i < this.tipoIng.length; i++) {
      const tipo = this.tipoIng[i];
      // console.log('tipo:: ', tipo);
      this.formArray.push(this._formBuilder.group({
        tipoOcupacionLabel: tipo.TRAEXP_Tipo,
        tipoOcupacionId: tipo._TRAEXP_Id,
        tipoOcupacionCheck: new FormControl(false, { validators: Validators.required, updateOn: 'blur' }),
      }));
      // console.log('formARrray', this.formArray);
      //console.log('comenzo la creacion de bnup');


    }
    // const idsTiposOcupaciones = [];
    //  this.formArray = <FormArray> this.formTipo.controls.ArrForms;
    // this.formArray.forEach((tipo, index) => {
    //    console.log('tipo:: ', tipo);
    //    if (tipo.tipoOcupacionCheck) {
    //      idsTiposOcupaciones.push(tipo.tipoOcupacionId);
    //    }
    //  });

    //  idsTiposOcupaciones
    //  console.log('idsTIposOCupaciones',idsTiposOcupaciones);



  }

}